import React, { useEffect, useState } from "react";
import {
  ChevronDownCircle,
  ChevronRightCircle,
  PackageX,
  CheckCircle,
  XCircle,
  Edit2,
  Check,
  X,
  Eye,
  PlusCircle,
  PauseCircle,
  PlayCircle,
  Trash2,
  Download,
} from "lucide-react";
import { Table, Button, Modal } from "antd";
import orderServices from "../../services/order.service";
import { toast } from "react-toastify";
import {
  Pagination,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import "antd/dist/reset.css";
import { useAuthStore } from "../../store/useAuthStore";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmDialog from "../Dialog/ConfirmDialog";
import DeleteSkuConfirmation from "../Model/DeleteConfirmation";
import "./order.css";

function OrderTable({
  orderListData = [],
  isLoading = true,
  setSelectedOrderId,
  setDeliveryModalOpen,
  setOrderDeleteModalOpen,
  totalPage = 0,
  pageNumber = 1,
  handlePageChange,
  searchData,
  filters,
}) {
  const { user } = useAuthStore();
  const USER_ROLE = user?.userDataObj?.role;
  const navigate = useNavigate();
  const location = useLocation();
  const expandOrderId = location.state?.order_id || null;
  const [expandedOrders, setExpandedOrders] = useState(new Set());
  const [subOrders, setSubOrders] = useState([]);
  const [subOrderItems, setSubOrderItems] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editableSubOrders, setEditableSubOrders] = useState({});
  const [editableUpdateSubOrders, setEditableUpdateSubOrders] = useState({});
  const [isSubmitModalVisible, setSubmitModalVisible] = useState(false);
  const [currentOrderId, setCurrentOrderId] = useState(null);
  const [currentProductId, setCurrentProductId] = useState(null);
  const [dialogVisible, setIsDialogVisible] = useState(false);
  const [currentDistributorId,setCurrentDistributorId] = useState(null);
  const [holdDialogVisible, setIsHoldDialogVisible] = useState(false);
  const [releaseDialogVisible, setIsReleaseDialogVisible] = useState(false);
  const [editingInvoice, setEditingInvoice] = useState(null);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [totalOrderItems, setTotalOrderItems] = useState(0);
  const [orderItemCurrentPage, setOrderItemCurrentPage] = useState(1);
  const [orderData, setOrderData] = useState({});

  const onDeleteClose = () => {
    setShowDeleteModel(false);
  };

  const calculateTotalSets = () => {
    return subOrders.reduce((total, item) => {
      let quantity;
      console.log(USER_ROLE, "USER_ROLE");
      if (USER_ROLE !== 4) {
        quantity =
          editableUpdateSubOrders[item.product_id] ?? item.ordered_sets ?? 0;
      } else {
        quantity = item.ordered_quantity ?? 0;
      }

      const setsPerUnit = item?.skuMaster?.skuSegment?.no_of_sets ?? 1;
      return total + quantity * setsPerUnit;
    }, 0);
  };

  const onConfirm = async () => {
    console.log(orderData);
    try {
      const response = await orderServices.deleteSku({
        user_id: user?.userDataObj?.user_id,
        order_id: orderData.order_id,
        sku_order_id: orderData.id,
        product_id: orderData.product_id,
      });
      if (response?.status === true) {
        toast?.success("SKU deleted successfully.", {
          toastId: "successMessageOnConfirm",
        });
        expandedOrders.delete(currentOrderId);
        toggleOrderExpansion(currentOrderId);
        handleUpdate(orderData.product_id);
      } else {
        toast?.error(response?.message || "Failed to delete SKU.", {
          toastId: "errorMessage",
        });
      }
      setShowDeleteModel(false);
    } catch (err) {
      toast?.error(err?.message || "Failed to delete SKU.", {
        toastId: "errorMessage",
      });
    } finally {
      setShowDeleteModel(false);
    }
  };

  const toggleOrderExpansion = async (orderId) => {
    const newExpanded = new Set(expandedOrders);
    setSubOrders([]);
    setEditableSubOrders({});
    setEditableUpdateSubOrders({});
    setEditableSubOrders({});
    setCurrentOrderId(null);
    if (newExpanded.has(orderId)) {
      newExpanded.delete(orderId);
    } else {
      try {
        setLoading(true);
        newExpanded.clear();
        setExpandedOrders(newExpanded);
        newExpanded.add(orderId);
        const params = { order_id: orderId, skipLimit: true };
        const response = await orderServices.getSkuOrderList(params);
        // console.log("rrrrrrrr",response);
        if (response.status) {
          setSubOrders(response.data);
          console.log(response.data, "status approved");
          response.data.map((order) => {
            setEditableUpdateSubOrders((prev) =>
              USER_ROLE === 3
                ? { ...prev, [order.product_id]: order?.ordered_quantity }
                : { ...prev, [order.product_id]: order?.ordered_quantity }
            );

            let availableStock =
              Math.floor(((order?.skuMaster?.productInventorySummary?.available_stock ||
                0) - order?.skuMaster?.productInventorySummary?.requested_stock)/ order?.skuMaster?.skuSegment?.no_of_sets);
                console.log(order?.ordered_quantity, "order?.ordered_quantity");
                

            setEditableSubOrders((pre) => ({
              ...pre,
              [order.product_id]:
                availableStock > order?.ordered_quantity
                  ? order?.ordered_quantity
                  : availableStock,
            }));
          });
          setCurrentOrderId(orderId);
        } else {
          newExpanded.delete(orderId);
          setSubOrders([]);
          toast.error("Fail to fetch sku details.", {
            toastId: "errorMessageToogleOrderExpansion",
          });
        }
      } catch (error) {
        newExpanded.delete(orderId);
        setSubOrders([]);
        toast.error(error.message || "Fail to fetch sku details.", {
          toastId: "errorMessageToogleOrderExpansion",
        });
      } finally {
        setLoading(false);
      }
    }
    setExpandedOrders(newExpanded);
  };

  const handleDeliveryConfirm = (orderId) => {
    setSelectedOrderId(orderId);
    setDeliveryModalOpen(true);
  };

  const handleDeleteOrder = (orderId) => {
    setSelectedOrderId(orderId);
    setOrderDeleteModalOpen(true);
    setExpandedOrders(new Set());
  };

  const fetchSkuItems = async (orderId, productId) => {
    setCurrentProductId(productId);
    const params = {
      order_id: orderId,
      product_id: productId,
      limit: 10,
      offset: orderItemCurrentPage,
    };
    try {
      const response = await orderServices.getSkuOrderItemList(params);
      // console.log("rrrrrrrr",response);
      if (response.status) {
        setSubOrderItems(response.data);
        setTotalOrderItems(response?.totalCount);
        setIsModalVisible(true);
      } else {
        toast.error("Fail to fetch sku details.", {
          toastId: "errorMessageFetchSkuItems",
        });
        setSubOrderItems([]);
        setTotalOrderItems(0);
      }
    } catch (error) {
      setSubOrderItems([]);
      setTotalOrderItems(0);
      toast.error(error.message || "Fail to fetch sku details.", {
        toastId: "errorMessageFetchSkuItems",
      });
    }
  };
  const handleSubmit = async () => {
    try {
      setLoading(true);
      // console.log("editableSubOrders",editableSubOrders);
      const productIds = Object.keys(editableSubOrders).map((value) =>
        Number(value)
      );
      // console.log(productIds);

      const notApproved = subOrders.filter(
        (order) =>
          !productIds.includes(order.product_id) && order.status_id === 4
      );
      if (notApproved.length > 0) {
        // console.log("-------",notApproved);
        return toast.info("Please approve all sku order.");
      }
      // const updatedOrders = subOrders.map(order => ({
      //   product_id: order.product_id,
      //   approved_quantity: editableSubOrders[order.product_id]
      // })).filter(value => value?.approved_quantity != undefined && value?.approved_quantity != null);
      const updatedOrders = subOrders.reduce((acc, order) => {
        const approved_quantity = editableSubOrders[order.product_id] || 0;
        if (approved_quantity !== undefined && approved_quantity !== null) {
          acc.push({ product_id: order.product_id, approved_quantity });
        }
        return acc;
      }, []);
      // console.log("---- updatedOrders  ----",updatedOrders);
      const response = await orderServices.approvedOrder({
        order_id: currentOrderId,
        order_details: updatedOrders,
      });
      // console.log("---response--",response);
      if (response.status) {
        toast.success("Orders Approved successfully", {
          toastId: "successMessageHandleSubmit",
        });
        // setSubmitModalVisible(false);
        // Refresh the orders list
        searchData();
        setExpandedOrders(new Set());
        toggleOrderExpansion(currentOrderId);
        // searchData();
      } else {
        toast.error(response.message || "Failed to update orders", {
          toastId: "errorMessageHandleSubmit",
        });
      }
    } catch (error) {
      toast.error(error.message || "Failed to update orders", {
        toastId: "errorMessageHandleSubmit",
      });
    } finally {
      setLoading(false);
      setSubmitModalVisible(false);
    }
  };

  const handleUpdate = async (deleteId = null) => {
    console.log("deleteId", deleteId);
    try {
      setLoading(true);
      const previousQuantity = {};

      subOrders.forEach((order) => {
        if (deleteId && order.product_id === deleteId) return;
        previousQuantity[order.product_id] = order?.ordered_quantity;
      });

      console.log(previousQuantity, "previousQuantity");
      // only update update quantities rest keep same
      const updatedOrdersQunatity = {
        ...previousQuantity,
        ...editableUpdateSubOrders,
      };
      // console.log("---- updatedOrders  ----",updatedOrdersQunatity);
      let updatedSubOrders = subOrders;
      if (deleteId) {
        updatedSubOrders = subOrders.filter(
          (order) => order.product_id !== deleteId
        );
      }
      const updatedOrders = updatedSubOrders
        .map((order) => ({
          product_id: order.product_id,
          ordered_quantity: updatedOrdersQunatity[order.product_id],
          status_id: order.status_id,
        }))
        .filter(
          (order) =>
            order?.status_id != 20 &&
            order?.status_id != 12 &&
            order?.ordered_quantity > 0
        );
      // console.log("---- updatedOrders  ----",updatedOrders);
      if (updatedOrders.length == 0)
        return toast.info("Atleast one sku order should be present for order.");
      const response = await orderServices.updateOrder({
        order_id: currentOrderId,
        order_details: updatedOrders,
        distributor_id: currentDistributorId || user?.userDataObj?.user_id,
      });
      // console.log("---response--",response);
      if (response.status) {
        setExpandedOrders(new Set());
        if (!deleteId) {
          toast.success("Orders updated successfully", {
            toastId: "successMessageHandleUpdate",
          });
        }
        // setIsDialogVisible(false);
        // Refresh the orders list
        searchData();
        toggleOrderExpansion(currentOrderId);
      } else {
        toast.error(response.message || "Failed to update orders", {
          toastId: "errorMessageHandleUpdate",
        });
      }
    } catch (error) {
      toast.error(error.message || "Failed to update orders", {
        toastId: "errorMessageHandleUpdate",
      });
    } finally {
      setLoading(false);
      setIsDialogVisible(false);
    }
  };
  const handleQuantityChange = (productId, value, actualOrderCount) => {
    console.log(value, "value");
    if (value > 1000) {
      toast.dismiss();
      return toast.info("Quantity exceed. Maximum allowed 1000.", {
        toastId: "quantityLimit",
      });
    }
    setEditableUpdateSubOrders((prev) => ({
      ...prev,
      [productId]: value,
    }));
  };

  const handleApprovedQuantity = (productId, value, actualOrderCount) => {
    console.log("actualOrderCount", actualOrderCount);
    if (value > actualOrderCount)
      return toast.info(
        "Approved sets can not be greater than the actual count.",
        { toastId: "approvedLimit" }
      );
    setEditableSubOrders((prev) => ({
      ...prev,
      [productId]: value,
    }));
  };
  const handleInvoiceEdit = (orderId, currentInvoice) => {
    setEditingInvoice({ orderId, value: currentInvoice || "" });
  };

  const handleInvoiceSave = async (orderId) => {
    if (!editingInvoice || !editingInvoice?.value) return;
    try {
      setLoading(true);
      const body = {
        order_id: orderId,
        invoice_number: editingInvoice?.value,
        user_id: user?.userDataObj?.user_id,
      };
      const response = await orderServices.updateOrderInvoiceNumber(body);
      if (!response.status)
        return toast.error(
          response?.message || "Fail to update invoice number.",
          { toastId: "errorMessageHandleInvoiceSave" }
        );
      toast.success("Invoice number update successfully.", {
        toastId: "successMessageHandleInvoiceSave",
      });
      await searchData();
      setEditingInvoice(null);
    } catch (error) {
      console.error("Failed to update invoice number:", error);
      toast.error(error.message || "Fail to update invoice number.", {
        toastId: "errorMessageHandleInvoiceSave",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInvoiceCancel = () => {
    setEditingInvoice(null);
  };

  const handleAddProduct = (orderId) => {
    if (filters && Object.keys(filters).length > 0) {
      localStorage.setItem("orderFilter", JSON.stringify(filters));
    }
    navigate("/add-product-list", { state: { order_id: orderId } });
  };

  const handleHoldOrder = async () => {
    try {
      const body = {
        order_id: currentOrderId,
        user_id: user?.userDataObj?.user_id,
      };
      const response = await orderServices.holdOrder(body);
      if (!response.status)
        return toast(response.message || "Failed to hold order");
      toast(response.message || "Order has been put on hold successfully...");
      searchData();
    } catch (error) {
      console.error("Failed to hold order:", error);
    } finally {
      setIsHoldDialogVisible(false);
      setCurrentOrderId(null);
    }
  };

  const handleReleaseOrder = async () => {
    try {
      const body = {
        order_id: currentOrderId,
        user_id: user?.userDataObj?.user_id,
      };
      const response = await orderServices.releaseOrder(body);
      if (!response.status)
        return toast(response.message || "Failed to release order");
      toast(response.message || "Order has been released successfully...");
      searchData();
    } catch (error) {
      console.error("Failed to release order:", error);
    } finally {
      setIsReleaseDialogVisible(false);
      setCurrentOrderId(null);
    }
  };

  const handleDownloadInvoice = (order) => {
    console.log("Download Invoice", order);
  };

  const handleDownloadCreditDebit = (order) => {
    console.log("Download Credit/Debit Note", order);
  };

  useEffect(() => {
    if (expandOrderId !== null) {
      toggleOrderExpansion(expandOrderId);
    }
  }, [expandOrderId]);
  useEffect(() => {
    if (currentOrderId && currentProductId) {
      fetchSkuItems(currentOrderId, currentProductId);
    }
  }, [orderItemCurrentPage]);

  console.log("subOrders", subOrders);
  console.log("editableSubOrders", editableSubOrders);

  console.log(editableUpdateSubOrders, "editableUpdateSubOrders");

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
        </div>
      </div>
    );
  }
  const NoDataFound = () => (
    <div className="flex flex-col items-center justify-center py-12 bg-white rounded-lg">
      <PackageX size={48} className="text-gray-400 mb-4" />
      <h3 className="text-lg font-medium text-dark mb-2">No Orders Found</h3>
      <p className="text-sm text-gray-500">
        No orders match your current filters or there are no orders available.
      </p>
    </div>
  );

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="flex justify-center items-center h-64 min-h-full overflow-y-auto mb-2">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600"></div>
        </div>
      ) : orderListData.length === 0 ? (
        <NoDataFound />
      ) : (
        <div className="order-table-scroll-wrapper overflow-auto h-[250px] sm:h-[400px] md:h-[450px] xl:h-[585px] bg-white rounded-lg shadow">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="order-table-header bg-emerald-200">
              <tr>
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Order Details
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Date
                </th>
                {(USER_ROLE === 4 || USER_ROLE === 5) && (
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                    >
                      Distributor Name
                    </th>
                    )}
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                    >
                      Added By
                    </th>
                    {(USER_ROLE === 4 || USER_ROLE === 5) && (
                    <>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                    >
                      Zonal Manager Name
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                    >
                      Mobile
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                    >
                      State
                    </th>

                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                    >
                      District
                    </th>

                    <th
                      scope="col"
                      className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                    >
                      Zone
                    </th>
                  </>
                )}

                <th
                  scope="col"
                  className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Total Billing Value (₹)
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Total Sets
                </th>
                {/* <th
                  scope="col"
                  className="px-4 py-3 text-left text-sm font-bold text-gray-500 whitespace-nowrap tracking-wider"
                >
                  Approved Amount
                </th> */}
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Approved Date
                </th>

                <th
                  scope="col"
                  className="px-5 py-3 text-center text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Status
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Expected Date
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Invoice No.
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Invoice Date
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Invoice Value (₹)
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Invoice PDF
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  LR No.
                </th>
                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Delivered Date
                </th>
                {/* <th
                  scope="col"
                  className="px-5 py-3 text-center text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Download Invoice
                </th>

                <th
                  scope="col"
                  className="px-5 py-3 text-center text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Download Credit/Debit Note
                </th> */}

                <th
                  scope="col"
                  className="px-5 py-3 text-left text-sm font-bold text-gray-700 whitespace-nowrap tracking-wider"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {console.log(orderListData, "orderListData sss")}
              {orderListData.map((order) => (
                <React.Fragment key={order.order_id}>
                  <tr>
                    <td className="px-5 py-1">
                      <div className="flex items-start w-40">
                        <button
                          onClick={() => toggleOrderExpansion(order.order_id)}
                          className="mr-2 text-gray-500 hover:text-gray-700 mt-0.5"
                        >
                          {expandedOrders.has(order.order_id) ? (
                            <ChevronDownCircle size={20} />
                          ) : (
                            <ChevronRightCircle size={20} />
                          )}
                        </button>
                        {/* <div className="text-sm font-medium text-gray-900"> */}
                        {order?.master_parent_order_id &&
                        order?.order_sequence_alphabet
                          ? `${order?.master_parent_order_id}-${order?.order_sequence_alphabet}`
                          : order.order_id}
                        {/* </div> */}
                      </div>
                    </td>
                    <td className="px-4 py-1 whitespace-nowrap text-sm text-dark">
                      {order.order_date || "N/A"}
                    </td>
                    {(USER_ROLE === 4 || USER_ROLE === 5) && (
                      <>
                        <td className="px-4 py-1 whitespace-nowrap text-sm text-dark">
                          {order.distributor_user?.distributor_name ||
                            `${order.distributor_user?.firstName || ""}  ${
                              order.distributor_user?.lastName || ""
                            }`}
                        </td>

                        </>
                    )}
                        
                        <td className="px-3 py-1 whitespace-nowrap text-sm text-dark">
                          {order?.added_by_type
                        ? order.added_by_type.toLowerCase().replace(/(^\w|_\w)/g, m => m.replace("_", " ").toUpperCase())
                        : "N/A"}
                        </td>
                        {(USER_ROLE === 4 || USER_ROLE === 5) && (
                      <>
                        <td className="px-3 py-1 whitespace-nowrap text-sm text-dark">
                          {order?.manager_name || "N/A"}
                        </td>
                        <td className="px-3 py-1 whitespace-nowrap text-sm text-dark">
                          {order?.distributor_user?.mobile || "N/A"}
                        </td>

                        <td className="px-3 py-1 whitespace-nowrap text-sm text-dark">
                          {order?.distributor_user?.state?.name || "N/A"}
                        </td>
                        <td className="px-3 py-1 whitespace-nowrap text-sm text-dark">
                          {order?.distributor_user?.district?.name || "N/A"}
                        </td>
                        <td className="px-3 py-1 whitespace-nowrap text-sm text-dark">
                          {order?.distributor_user?.regionMaster?.name || "N/A"}
                        </td>
                      </>
                    )}
                    <td className="px-4 py-1 whitespace-nowrap text-sm text-dark">
                      {order.approved_amount || order.order_amount || 0}
                    </td>
                    <td className="px-4 py-1 whitespace-nowrap text-sm text-dark text-right">
                      {(order?.status_id === 11
                        ? order?.total_approved_sets
                        : order?.total_ordered_sets) ?? 0}
                    </td>
                    {/* <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
                      {order.order_amount || "N/A"}
                    </td> */}
                    <td className="px-5 py-1 whitespace-nowrap text-sm text-dark">
                      {order.approved_date || "N/A"}
                    </td>
                    <td className="px-5 py-1">
                      <span
                        className={`px-4 py-1 whitespace-nowrap inline-flex text-xs text-center leading-5 font-semibold rounded-full ${
                          order?.status_id === 14 || order?.status_id === 18
                            ? "bg-green-100 text-green-800"
                            : order?.status_id === 12
                            ? "bg-red-100 text-red-800"
                            : "bg-yellow-100 text-yellow-800"
                        }`}
                      >
                        {order.statusMaster?.display_status}
                      </span>
                    </td>
                    <td className="px-5 py-1 whitespace-nowrap text-sm text-dark">
                      {order.expected_date || "N/A"}
                    </td>
                    <td className="px-5 py-1 whitespace-nowrap text-sm text-dark">
                      {/* {order.status_id === 4 && USER_ROLE === 4 ? (
                        editingInvoice?.orderId === order.order_id ? (
                          <div className="flex items-center gap-2">
                            <input
                              type="text"
                              value={editingInvoice.value}
                              onChange={(e) =>
                                setEditingInvoice({
                                  ...editingInvoice,
                                  value: e.target.value,
                                })
                              }
                              className="border border-gray-300 rounded px-2 py-1 w-32"
                              placeholder="Enter invoice #"
                            />
                            <button
                              onClick={() => handleInvoiceSave(order.order_id)}
                              className="text-green-600 hover:text-green-700"
                            >
                              <Check size={18} />
                            </button>
                            <button
                              onClick={handleInvoiceCancel}
                              className="text-red-600 hover:text-red-700"
                            >
                              <X size={18} />
                            </button>
                          </div>
                        ) : (
                          <div className="flex items-center gap-2">
                            <span>{order.invoice_number || "N/A"}</span>
                            <button
                              onClick={() =>
                                handleInvoiceEdit(
                                  order.order_id,
                                  order.invoice_number
                                )
                              }
                              className="text-blue-600 hover:text-blue-700"
                            >
                              <Edit2 size={18} />
                            </button>
                          </div>
                        )
                      ) : (
                        order.invoice_number || "N/A"
                      )} */}
                      {order.invoice_number || "N/A"}
                    </td>
                    <td className="px-5 py-1 whitespace-nowrap text-sm text-dark">
                      {order.invoice_date || "N/A"}
                    </td>
                    <td className="px-5 py-1 whitespace-nowrap text-sm text-dark">
                      {order.invoice_amount || "N/A"}
                    </td>
                    <td className="px-5 py-1 whitespace-nowrap text-sm text-dark">
                      {order.invoice_pdf ? (
                        <a
                          href={order.invoice_pdf}
                          target="_blank"
                          rel="noreferrer"
                          className="text-emerald-700 hover:underline"
                        >
                          View
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td className="px-5 py-1 whitespace-nowrap text-sm text-dark">
                      {order.lr_no || "N/A"}
                    </td>

                    <td className="px-5 py-1 whitespace-nowrap text-sm text-dark">
                      {order.delivered_confirm_date || "N/A"}
                    </td>
                    {/* <td className="px-5 py-1 whitespace-nowrap text-center">
                      <button
                        onClick={() => handleDownloadInvoice(order)}
                        className="text-emerald-600 hover:text-emerald-700"
                      >
                        <Download size={18} />
                      </button>
                    </td>

                    <td className="px-5 py-1 whitespace-nowrap text-center">
                      <button
                        onClick={() => handleDownloadCreditDebit(order)}
                        className="text-emerald-600 hover:text-emerald-700"
                      >
                        <Download size={18} />
                      </button>
                    </td> */}

                    <td className="px-5 py-1 text-sm font-medium gap-3 flex justify-between items-center">
                      {USER_ROLE === 3 && (
                        <Button
                          variant="contained"
                          onClick={() => handleDeliveryConfirm(order.order_id)}
                          className="bg-emerald-600 hover:bg-emerald-700 text-white w-32 py-2 mb-1"
                          disabled={
                            ![13, 14, 15, 16].includes(order?.status_id)
                          }
                        >
                          Confirm Delivery
                        </Button>
                      )}

                      <Button
                        variant="contained"
                        onClick={() => handleDeleteOrder(order.order_id)}
                        className="bg-red-600 hover:bg-red-700 text-white w-32 py-1"
                        disabled={
                          order?.status_id !== 4 ||
                          (USER_ROLE !== 4 && USER_ROLE !== 3)
                        }
                      >
                        {USER_ROLE === 4 ? "Reject Order" : "Cancel Order"}
                      </Button>

                      {USER_ROLE === 4 && (
                        <>
                          {order.status_id !== 4 ? (
                            <Button
                              variant="contained"
                              onClick={() => {
                                setCurrentOrderId(order.order_id);
                                setIsReleaseDialogVisible(true);
                              }}
                              className="bg-emerald-600 hover:bg-emerald-700 text-white w-32 py-2 mt-1"
                              icon={<PlayCircle size={14} />}
                              disabled={![19].includes(order?.status_id)}
                            >
                              Release Order
                            </Button>
                          ) : (
                            <Button
                              variant="contained"
                              onClick={() => {
                                setCurrentOrderId(order.order_id);
                                setIsHoldDialogVisible(true);
                              }}
                              className="bg-emerald-600 hover:bg-orange-700 text-white w-32 py-2 mt-1"
                              icon={<PauseCircle size={14} />}
                              disabled={![4].includes(order?.status_id)}
                            >
                              Hold Order
                            </Button>
                          )}
                        </>
                      )}
                    </td>
                  </tr>
                  {expandedOrders.has(order.order_id) && (
                    <tr>
                      <td
                        colSpan={USER_ROLE === 4 || USER_ROLE === 5 ? 19 : 10}
                        className="px-4 py-2"
                      >
                        <div className="bg-gray-50 p-4 rounded-lg">
                          <div className="overflow-x-auto">
                            <div className="flex justify-between items-center mb-4">
                              <h3 className="text-lg font-semibold text-gray-900">
                                SKU Details
                              </h3>
                              {USER_ROLE === 3 && order.status_id == 4 && (
                                <button
                                  onClick={() =>
                                    handleAddProduct(order.order_id)
                                  }
                                  className="inline-flex items-center px-3 py-1.5 bg-emerald-600 text-white text-sm font-medium rounded-md hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
                                >
                                  <PlusCircle className="mr-1.5 h-4 w-4" />
                                  Add Product
                                </button>
                              )}
                            </div>
                            <table className="min-w-full divide-y divide-gray-200">
                              <thead className="bg-emerald-100">
                                <tr>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Part Number
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Segment
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Size
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Make
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Status
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    No. Of Sets to Order ({calculateTotalSets()}
                                    )
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    MRP Per Set (₹)
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Ordered Sets
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Approved Sets
                                  </th>
                                  {USER_ROLE === 4 && (
                                    <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                      Available Sets
                                    </th>
                                  )}
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Billing Value (₹)
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    Billing Approved Value (₹)
                                  </th>
                                  <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                    View Details
                                  </th>
                                  {USER_ROLE !== 4 &&
                                    order?.statusMaster?.display_status ===
                                      "Order Placed" && (
                                      <th className="px-4 py-2 text-left text-xs font-bold text-gray-700">
                                        Delete
                                      </th>
                                    )}
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td
                                      colSpan={10}
                                      className="py-12 text-center"
                                    >
                                      <div className="flex justify-center">
                                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600"></div>
                                      </div>
                                    </td>
                                  </tr>
                                ) : (
                                  <>
                                    {subOrders.map((subOrder) => (
                                      <tr
                                        key={subOrder.id}
                                        className="hover:bg-gray-100"
                                      >
                                        <td className="px-4 py-2 text-sm text-dark">
                                          {subOrder.skuMaster?.part_no || "N/A"}
                                        </td>
                                        <td className="px-4 py-2 text-sm text-dark">
                                          {subOrder.skuMaster?.skuSegment
                                            ?.segment || "N/A"}
                                        </td>
                                        <td className="px-4 py-2 text-sm text-dark">
                                          {subOrder.skuMaster?.skuSize?.size ||
                                            "N/A"}
                                        </td>
                                        <td className="px-4 py-2 text-sm text-dark">
                                          {subOrder.skuMaster?.skuMake?.make ||
                                            "N/A"}
                                        </td>
                                        <td className="px-2 py-2 text-sm text-dark">
                                          {subOrder.statusMaster
                                            ?.display_status || "N/A"}
                                        </td>
                                        <td className="px-2 py-2 text-sm text-center text-dark flex items-center justify-center whitespace-nowrap">
                                          {
                                            subOrder?.skuMaster?.skuSegment
                                              ?.no_of_sets
                                          }{" "}
                                          <X size={12} />
                                          {(order.status_id == 4 &&
                                          subOrder.status_id === 4 &&
                                          (USER_ROLE === 3 || USER_ROLE === 5)) ? (
                                            <>
                                              <TextField
                                                type="number"
                                                size="small"
                                                style={{ width: "100px" }}
                                                disabled={!((order.status_id === 4 && USER_ROLE === 5) || (order.status_id === 4 && USER_ROLE === 3 && order.manager_name === "" ))}
                                                value={
                                                  editableUpdateSubOrders[
                                                    subOrder.product_id
                                                  ]
                                                }
                                                onChange={(e) =>
                                                  handleQuantityChange(
                                                    subOrder.product_id,
                                                    Math.max(
                                                      0,
                                                      parseInt(
                                                        e.target.value
                                                      ) || 0
                                                    ),
                                                    subOrder.ordered_quantity
                                                  )
                                                }
                                              />
                                              &nbsp; ={" "}
                                              {editableUpdateSubOrders[
                                                subOrder.product_id
                                              ] *
                                                subOrder?.skuMaster?.skuSegment
                                                  ?.no_of_sets}
                                            </>
                                          ) : (
                                            subOrder.ordered_quantity || 0
                                          )}
                                        </td>
                                        <td className="px-4 py-2 text-sm text-right text-dark">
                                          {subOrder?.skuMaster?.default_mrp ||
                                            0}
                                        </td>
                                        <td className="px-4 py-2 text-sm text-right text-dark">
                                          {USER_ROLE !== 4
                                            ? editableUpdateSubOrders[
                                                subOrder.product_id
                                              ] *
                                                subOrder?.skuMaster?.skuSegment
                                                  ?.no_of_sets || 0
                                            : editableUpdateSubOrders[
                                                subOrder.product_id
                                              ] *
                                              subOrder?.skuMaster?.skuSegment
                                                ?.no_of_sets}
                                        </td>
                                        {
                                          USER_ROLE === 4 ? (
                                            <td className="px-4 py-2 text-sm text-right text-dark flex items-center justify-center whitespace-nowrap">
                                              {subOrder?.skuMaster?.skuSegment?.no_of_sets} <X size={12} />
                                              {order.status_id === 4 && subOrder.status_id === 4 && USER_ROLE === 4 ? (
                                                <TextField
                                                  type="number"
                                                  size="small"
                                                  sx={{ width: "80px" }}
                                                  value={editableSubOrders[subOrder.product_id]}
                                                  onChange={(e) =>
                                                    handleApprovedQuantity(
                                                      subOrder.product_id,
                                                      Math.max(0, parseInt(e.target.value) || 0),
                                                      subOrder.ordered_quantity
                                                    )
                                                  }
                                                  InputProps={{
                                                    inputProps: {
                                                      min: 0,
                                                      max: subOrder.ordered_quantity,
                                                    },
                                                  }}
                                                />
                                              ) : (
                                                subOrder.approved_quantity || 0
                                              )}
                                              &nbsp; ={" "}
                                              {subOrder.statusMaster?.display_status === "Order Placed"
                                                ? editableSubOrders[subOrder.product_id] *
                                                    subOrder?.skuMaster?.skuSegment?.no_of_sets
                                                : subOrder?.approved_quantity *
                                                    subOrder?.skuMaster?.skuSegment?.no_of_sets}
                                            </td>
                                          ) : (
                                            <td className="px-2 py-2 text-sm text-center text-dark flex items-center justify-center whitespace-nowrap">{subOrder?.approved_sets || 0}</td>
                                          )
                                        }
                                        {USER_ROLE === 4 && (
                                          <td className="px-4 py-2 text-sm text-dark text-right">
                                            {(subOrder?.skuMaster
                                              ?.productInventorySummary
                                              ?.available_stock || 0) -
                                              (subOrder?.skuMaster
                                                ?.productInventorySummary
                                                ?.requested_stock || 0)}
                                          </td>
                                        )}
                                        <td className="px-4 py-2 text-sm text-right text-dark">
                                          {/* current 
                                          {editableUpdateSubOrders[
                                                  subOrder.product_id
                                                ]} <br /> */}
                                          {USER_ROLE === 4
                                            ? (
                                                editableUpdateSubOrders[
                                                  subOrder.product_id
                                                ] *
                                                  subOrder?.skuMaster
                                                    ?.skuSegment?.no_of_sets *
                                                  subOrder?.skuMaster
                                                    ?.default_mrp -
                                                (editableUpdateSubOrders[
                                                  subOrder.product_id
                                                ] *
                                                  subOrder?.skuMaster
                                                    ?.skuSegment?.no_of_sets *
                                                  subOrder?.skuMaster
                                                    ?.default_mrp *
                                                  subOrder?.discount_price) /
                                                  100
                                              ).toFixed(2) ?? 0
                                            : (
                                                editableUpdateSubOrders[
                                                  subOrder.product_id
                                                ] *
                                                  subOrder?.skuMaster
                                                    ?.skuSegment?.no_of_sets *
                                                  subOrder?.skuMaster
                                                    ?.default_mrp -
                                                (editableUpdateSubOrders[
                                                  subOrder.product_id
                                                ] *
                                                  subOrder?.skuMaster
                                                    ?.skuSegment?.no_of_sets *
                                                  subOrder?.skuMaster
                                                    ?.default_mrp *
                                                  subOrder?.discount_price) /
                                                  100
                                              ).toFixed(2) ?? 0}
                                        </td>
                                        <td className="px-4 py-2 text-sm text-dark text-right">
                                          {/* {(subOrder?.statusMaster?.display_status === 'Order Placed' ? editableSubOrders[
                                              subOrder.product_id
                                            ] : subOrder?.approved_sets)} <br /> */}
                                          {USER_ROLE === 4 ? (
                                            <>
                                              {(
                                                (subOrder?.statusMaster
                                                  ?.display_status ===
                                                "Order Placed"
                                                  ? editableSubOrders[
                                                      subOrder.product_id
                                                    ]
                                                  : subOrder.approved_quantity) *
                                                  subOrder.skuMaster?.skuSegment
                                                    ?.no_of_sets *
                                                  subOrder.skuMaster
                                                    .default_mrp -
                                                ((subOrder.statusMaster
                                                  ?.display_status ===
                                                "Order Placed"
                                                  ? editableSubOrders[
                                                      subOrder.product_id
                                                    ]
                                                  : subOrder.approved_quantity) *
                                                  subOrder.skuMaster?.skuSegment
                                                    .no_of_sets *
                                                  subOrder.skuMaster
                                                    ?.default_mrp *
                                                  subOrder.discount_price) /
                                                  100
                                              ).toFixed(2) || 0}
                                            </>
                                          ) : (
                                            <>
                                              {(
                                                subOrder.approved_quantity *
                                                  subOrder?.skuMaster
                                                    ?.skuSegment?.no_of_sets *
                                                  subOrder?.skuMaster
                                                    ?.default_mrp -
                                                (subOrder.approved_quantity *
                                                  subOrder?.skuMaster
                                                    ?.skuSegment?.no_of_sets *
                                                  subOrder?.skuMaster
                                                    ?.default_mrp *
                                                  subOrder?.discount_price) /
                                                  100
                                              ).toFixed(2) || 0}
                                            </>
                                          )}
                                        </td>
                                        {/* <td className="px-4 py-2 text-sm text-gray-500">
                                          <Button
                                            onClick={() =>
                                              fetchSkuItems(
                                                subOrder.order_id,
                                                subOrder.product_id
                                              )
                                            }
                                            className="text-blue-600 hover:underline"
                                          >
                                            View SKU Items
                                          </Button>                                        
                                        </td> */}
                                        <td className="px-4 py-2">
                                          {subOrder.statusMaster
                                            ?.display_status !==
                                            "Order Rejected" && (
                                            <button
                                              disabled={
                                                subOrder.status_id === 12 ||
                                                subOrder.status_id === 20
                                              }
                                              onClick={() =>
                                                fetchSkuItems(
                                                  subOrder.order_id,
                                                  subOrder.product_id
                                                )
                                              }
                                              className="inline-flex items-center px-3 py-1 text-sm font-medium text-emerald-600 bg-emerald-100 rounded-md hover:bg-emerald-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
                                            >
                                              <Eye size={16} className="mr-1" />
                                              View Details
                                            </button>
                                          )}
                                        </td>
                                        {USER_ROLE !== 4 &&
                                          subOrder.statusMaster
                                            ?.display_status ===
                                            "Order Placed" && (
                                            <td className="px-4 py-4 text-sm text-red-900 text-center flex justify-center items-center">
                                              <Trash2
                                                onClick={() => {
                                                  setOrderData(subOrder);
                                                  setShowDeleteModel(true);
                                                }}
                                                size={16}
                                              />
                                            </td>
                                          )}
                                      </tr>
                                    ))}
                                  </>
                                )}
                              </tbody>
                            </table>
                            {order.status_id === 4 && USER_ROLE === 4 && (
                              <div className="mt-4 flex justify-end">
                                <Button
                                  variant="contained"
                                  onClick={() => setSubmitModalVisible(true)}
                                  className="bg-emerald-600 hover:bg-emerald-700 text-white"
                                >
                                  {/* Submit  */}
                                  Approved Sets
                                </Button>
                              </div>
                            )}
                            {((order.status_id === 4 && USER_ROLE === 5) || (order.status_id === 4 && USER_ROLE === 3 && order.manager_name === "" )) && (
                              <div className="mt-4 flex justify-end">
                                <Button
                                  variant="contained"
                                  onClick={() => {
                                    setCurrentDistributorId(order.distributor_user.id);
                                    setIsDialogVisible(true)
                                  }}
                                  className="bg-emerald-600 hover:bg-emerald-700 text-white"
                                >
                                  Update Order
                                </Button>
                              </div>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          <div className="flex justify-center py-4 mb-6">
            <Pagination
              count={totalPage}
              page={pageNumber}
              onChange={(event, value) => handlePageChange(value)}
              variant="outlined"
              shape="rounded"
              color="primary"
            />
          </div>
          {/* Approved quantity dialog */}
          <Dialog
            open={isSubmitModalVisible}
            onClose={() => setSubmitModalVisible(false)}
          >
            <DialogTitle>Confirm Submission</DialogTitle>
            <DialogContent>
              <p>Are you sure you want to submit the approved sets?</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setSubmitModalVisible(false)}>
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                disabled={loading}
                className="bg-emerald-600 hover:bg-emerald-700"
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>

          {/* Update quantity dialog */}
          <Dialog
            open={dialogVisible}
            onClose={() => setIsDialogVisible(false)}
          >
            <DialogTitle>Confirm Submission</DialogTitle>
            <DialogContent>
              <p>Are you sure you want to submit the updated sets?</p>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setIsDialogVisible(false)}>Cancel</Button>
              <Button
                variant="contained"
                onClick={handleUpdate}
                disabled={loading}
                className="bg-emerald-600 hover:bg-emerald-700"
              >
                Confirm
              </Button>
            </DialogActions>
          </Dialog>
          {/* sku Item data model */}
          <Modal
            title={
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "bold",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  position: "relative",
                }}
              >
                SKU Item Details
              </div>
            }
            open={isModalVisible}
            onCancel={() => {
              setIsModalVisible(false);
              setCurrentProductId(null);
              setOrderItemCurrentPage(1);
              setTotalOrderItems(0);
            }}
            footer={null}
            width={800}
          >
            {loading ? (
              <p>Loading...</p>
            ) : subOrderItems.length > 0 ? (
              <div style={{ maxHeight: "400px", overflow: "auto" }}>
                <Table
                  columns={[
                    {
                      title: "Redeem Id",
                      dataIndex: "redeem_id",
                      key: "redeem_id",
                    },
                    { title: "Amount", dataIndex: "amount", key: "amount" },
                    {
                      title: "Status",
                      key: "status",
                      render: (_, record) =>
                        record.statusMaster?.display_status || "N/A",
                    },
                    {
                      title: "Order Date",
                      dataIndex: "item_order_date",
                      key: "item_order_date",
                    },
                    {
                      title: "Master Carton Code",
                      key: "container_code",
                      render: (_, record) =>
                        record.container_code || "Not Available",
                    },
                    {
                      title: "Added By",
                      key: "added_by",
                      render: (_, record) =>
                        record.addedByUser
                          ? `${record.addedByUser.firstName} ${record.addedByUser.lastName}`
                          : "N/A",
                    },
                    {
                      title: "Dispatch Date",
                      key: "dispatch_date",
                      render: (_, record) =>
                        record.dispatch_date
                          ? record.dispatch_date
                          : "Not Dispatched",
                    },
                  ]}
                  dataSource={subOrderItems}
                  pagination={{
                    current: orderItemCurrentPage,
                    pageSize: 10,
                    total: totalOrderItems,
                    onChange: (page, size) => {
                      setOrderItemCurrentPage(page);
                    },
                  }}
                  scroll={{ x: true }}
                  components={{
                    header: {
                      cell: (props) => (
                        <th
                          {...props}
                          style={{
                            backgroundColor: "#A7F3D0",
                            color: "black",
                            fontWeight: "bold",
                            textAlign: "center",
                          }}
                        />
                      ),
                    },
                  }}
                />
              </div>
            ) : (
              <p className="text-center">No Data Found</p>
            )}
          </Modal>

          {/* hold and release confirmation dailog */}
          <ConfirmDialog
            isOpen={holdDialogVisible}
            setIsOpen={() => {
              setIsHoldDialogVisible(false);
              setCurrentOrderId(null);
            }}
            handler={handleHoldOrder}
            title="Confirmation"
            message="Are you sure you want to hold this order ?"
            position="center"
          />

          {showDeleteModel && (
            <DeleteSkuConfirmation
              onCancel={onDeleteClose}
              toggleOrderExpansion={toggleOrderExpansion}
              onConfirm={onConfirm}
            />
          )}

          <ConfirmDialog
            isOpen={releaseDialogVisible}
            setIsOpen={() => {
              setIsReleaseDialogVisible(false);
              setCurrentOrderId(null);
            }}
            handler={handleReleaseOrder}
            title="Confirmation"
            message="Are you sure you want to release this order ?"
            position="center"
          />
        </div>
      )}
    </React.Fragment>
  );
}

export default OrderTable;
